//frontend/src/components/Auth/ForgotPassword.jsx

import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, InputGroup } from 'react-bootstrap';
import { FaEnvelope, FaPaperPlane, FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';
import './Auth.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await api.post('/users/password-reset-request/', { email });
            setSuccess(true);
            toast.success('✅ Email de réinitialisation envoyé !');
        } catch (error) {
            const errorMsg = error.response?.data?.error || 
                            error.response?.data?.message || 
                            'Erreur lors de l\'envoi';
            setError(errorMsg);
            toast.error('❌ ' + errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <Container className="py-5">
                <Card className="shadow-lg" style={{ maxWidth: '550px', margin: '0 auto' }}>
                    <Card.Body className="p-5">
                        <div className="text-center mb-4">
                            <div className="mb-3">
                                <FaEnvelope size={60} className="text-primary" />
                            </div>
                            <h2 className="mb-2">Mot de passe oublié ?</h2>
                            <p className="text-muted">
                                Entrez votre email pour recevoir un lien de réinitialisation
                            </p>
                        </div>

                        {error && (
                            <Alert variant="danger" className="mb-4">
                                {error}
                            </Alert>
                        )}

                        {success ? (
                            <Alert variant="success" className="text-center">
                                <FaPaperPlane size={40} className="text-success mb-3" />
                                <h5 className="mb-3">Email envoyé !</h5>
                                <p className="mb-3">
                                    Un email de réinitialisation a été envoyé à <strong>{email}</strong>
                                </p>
                                <p className="text-muted mb-3">
                                    Vérifiez votre boîte de réception et vos spams. Le lien expire dans 24 heures.
                                </p>
                                <hr />
                                <div className="d-flex gap-2 justify-content-center">
                                    <Link to="/login" className="btn btn-primary">
                                        Retour à la connexion
                                    </Link>
                                    <Button 
                                        variant="outline-secondary"
                                        onClick={() => {
                                            setSuccess(false);
                                            setEmail('');
                                        }}
                                    >
                                        Renvoyer
                                    </Button>
                                </div>
                            </Alert>
                        ) : (
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-4">
                                    <Form.Label>Adresse email</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FaEnvelope />
                                        </InputGroup.Text>
                                        <Form.Control
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            placeholder="votre@email.com"
                                            size="lg"
                                        />
                                    </InputGroup>
                                    <Form.Text className="text-muted">
                                        Nous vous enverrons un lien pour réinitialiser votre mot de passe
                                    </Form.Text>
                                </Form.Group>

                                <Button 
                                    type="submit" 
                                    variant="primary" 
                                    className="w-100"
                                    size="lg"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                            Envoi en cours...
                                        </>
                                    ) : (
                                        <>
                                            <FaPaperPlane className="me-2" />
                                            Envoyer le lien
                                        </>
                                    )}
                                </Button>
                            </Form>
                        )}

                        <hr className="my-4" />

                        <div className="text-center">
                            <Link to="/login" className="text-primary">
                                <FaArrowLeft className="me-2" />
                                Retour à la connexion
                            </Link>
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default ForgotPassword;